import { render, staticRenderFns } from "./RiskCheckAllSafetyLogUpdate.vue?vue&type=template&id=2c7597bb&scoped=true&"
import script from "./RiskCheckAllSafetyLogUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskCheckAllSafetyLogUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RiskCheckAllSafetyLogUpdate.vue?vue&type=style&index=0&id=2c7597bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7597bb",
  null
  
)

export default component.exports